import { render, staticRenderFns } from "./noticeMessage.vue?vue&type=template&id=3e8ccdb0&scoped=true&"
import script from "./noticeMessage.vue?vue&type=script&lang=ts&"
export * from "./noticeMessage.vue?vue&type=script&lang=ts&"
import style0 from "./noticeMessage.vue?vue&type=style&index=0&id=3e8ccdb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8ccdb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
